import { useSelector } from "react-redux"
import { selectPrimarySecurity } from "../selectors/home"
import { getSecurityKey, isFnOSecurity } from "../util/security"
import { useMemo } from "react"

const useSelectPrimaryOrUnderlyingSecurity = () => {
    const {  expressionMode, primary, underlying } = useSelector(selectPrimarySecurity)
    const mainSecurity = useMemo(() => expressionMode ? underlying : (primary && isFnOSecurity(primary) ? underlying : primary), [expressionMode, primary, underlying]);
    return {
        primaryOrUnderlying: mainSecurity,
        primaryOrUnderlyingToken: mainSecurity ? getSecurityKey(mainSecurity.exchange, mainSecurity.code) : ""
    }

}

export default useSelectPrimaryOrUnderlyingSecurity